import { IntlShape } from "react-intl";
import {
  convertLabelToSpecificationKey,
  convertSpecificationKeyToLabel,
} from "../utils/specificationUtils";
import { FormValuesType } from "../components/Assets/types/assetTypes";
import { SpecificationItem } from "../components/Specifications/types/specificationTypes";

interface ISpecificationErrors {
  key?: string;
}

const isKeyMandatory = (specification: SpecificationItem) =>
  (specification?.key?.name !== "" || specification?.value !== "") &&
  (specification?.value?.length ?? 0) > 0 &&
  (specification?.key?.name === "" || !specification?.key);

const isKeyFormatInvalid = (
  specification: SpecificationItem,
  isUserProjectEngineer: boolean,
) => {
  const hasSpecialChars =
    specification?.key?.name?.toLowerCase() !==
    convertSpecificationKeyToLabel(
      convertLabelToSpecificationKey(specification?.key?.name),
    ).toLowerCase();
  return !isUserProjectEngineer && specification?.key?.name && hasSpecialChars;
};
const isDuplicateKey = (
  specification: SpecificationItem,
  allSpecifications: Array<SpecificationItem>,
) => {
  const hasDuplicateKeys =
    allSpecifications.filter(
      (s) =>
        s.key?.name &&
        convertLabelToSpecificationKey(s.key.name) ===
          convertLabelToSpecificationKey(specification?.key?.name),
    ).length > 1;
  return specification?.key?.name && hasDuplicateKeys;
};
const isKeyTooLong = (specification: SpecificationItem) =>
  (specification?.key?.name?.length ?? 0) > 100;
const isValueTooLong = (specification: SpecificationItem) =>
  (specification?.value?.length ?? 0) > 5000;

export default function validateSpecifications(
  intl: IntlShape,
  values: FormValuesType,
  isUserProjectEngineer: boolean = false,
) {
  if ((values?.specifications ?? []).length <= 0) {
    return undefined;
  }
  const errors: ISpecificationErrors[] = [];
  values.specifications!.forEach(
    (specification, index: number, allSpecifications: SpecificationItem[]) => {
      const specificationErrors: ISpecificationErrors = {};
      if (isKeyMandatory(specification)) {
        specificationErrors.key = intl.formatMessage({
          id: "validation.specification_key.mandatory",
        });
      } else if (isKeyFormatInvalid(specification, isUserProjectEngineer)) {
        specificationErrors.key = intl.formatMessage({
          id: "validation.specification_key.format",
        });
      } else if (isDuplicateKey(specification, allSpecifications)) {
        specificationErrors.key = intl.formatMessage({
          id: "validation.specification_key.duplicate",
        });
      } else if (isKeyTooLong(specification)) {
        specificationErrors.key = intl.formatMessage({
          id: "validation.specification_key.too_long",
        });
      } else if (isValueTooLong(specification)) {
        specificationErrors.key = intl.formatMessage({
          id: "validation.specification_value.too_long",
        });
      }
      if (Object.keys(specificationErrors).length > 0) {
        errors[index] = specificationErrors;
      }
    },
  );

  return errors.length > 0 ? errors : undefined;
}
